import { configureStore } from '@reduxjs/toolkit';

import { environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { notifications } from '@paragon/notification-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { hangerPrices } from './hangerPricesSlice';
import { lumberInventories } from './lumberInventoriesSlice';
import { lumberPrices } from './lumberPricesSlice';
import { platePrices } from './platePricesSlice';
import { plateTypeProperties } from './plateTypePropertiesSlice';
import { view } from './viewSlice';

export const store = configureStore({
  reducer: {
    plateTypeProperties,
    lumberPrices,
    environment,
    logInData,
    lumberInventories,
    platePrices,
    hangerPrices,
    spinnerMessages,
    view,
    notifications,
    theme,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
